import { stringify } from 'query-string';
import { HttpClient } from 'api/http-client';
import {
  FieldSectionType,
  FieldSection,
  FieldSectionSubType,
  CreateFieldSectionPayload,
} from './types';

const baseUrl = '/field-sections';

interface UpdateFieldSectionOrderPayload {
  fieldId: number;
  fieldSectionId: number;
  fieldOrderIndex: number;
}

export class FieldSectionClient extends HttpClient {
  public getAllFieldSections = (
    sectionType: FieldSectionType,
    sectionSubType?: FieldSectionSubType,
  ): Promise<FieldSection[]> =>
    this.get<FieldSection[]>(
      `${baseUrl}?${stringify(
        {
          fieldSectionType: sectionType,
          fieldSectionSubType: sectionSubType,
        },
        { skipNull: true },
      )}`,
    );

  public createFieldSection = (
    fieldSectionPayload: CreateFieldSectionPayload,
  ): Promise<FieldSection> => this.post(baseUrl, fieldSectionPayload);

  public updateFieldSection = (
    fieldSection: Partial<FieldSection>,
  ): Promise<FieldSection> =>
    this.put(`${baseUrl}/${fieldSection.fieldSectionId}`, fieldSection);

  public deleteFieldSection = (fieldSectionId: number): Promise<void> =>
    this.delete<FieldSection, void>(`${baseUrl}/${fieldSectionId}`);

  public updateFieldSectionOrder = ({
    fieldId,
    fieldSectionId,
    fieldOrderIndex,
  }: UpdateFieldSectionOrderPayload): Promise<FieldSection[]> =>
    this.put(`${baseUrl}/${fieldSectionId}/update-order`, {
      fieldId,
      fieldOrderIndex,
    });
}

export const FieldSectionApi = new FieldSectionClient();
